import RSVP from 'rsvp'
import inject from 'helpers/inject'

import StorageService from 'services/storage'

export default class ApiService {

  storage = inject(StorageService)

  constructor() {
    if (this.storage.authToken)
      this.authorize(this.storage.authToken)
  }

  authToken = ''

  authorize(authToken) {
    this.authToken = authToken
  }

  request({ url, method = 'GET', data, headers = {} }) {
    return new RSVP.Promise((resolve, reject) => {
      try {

        headers['content-type'] = 'application/json'
        if (this.authToken)
          headers['Authorization'] = `Token ${this.authToken}`

        const fetchOptions = {
          method,
          headers
        }

        if (method !== 'GET' && data)
          fetchOptions.body = JSON.stringify(data)

        fetch(url, fetchOptions)
          .then(response => {
            if (!response.ok)
              throw new Error('Network problem')
            return response.json()
          })
          .then(result => resolve(result))
          .catch(error => reject(error))

      } catch (error) {
        reject(error)
      }
    })
  }

}




// WEBPACK FOOTER //
// ./src/services/api.js